module.exports = __webpack_public_path__ + "img/fiber-hero-img.0eca1e4e.png";